/**
 * react-input-mask의 마스크 패턴을 @react-input/mask 형식으로 변환합니다.
 * @param maskPattern - 변환할 마스크 패턴 (예: '9999.99.99')
 * @returns 변환된 마스크 패턴 (예: '____.__..__')
 */
export const convertMaskPattern = (maskPattern: string): string => {
  // 9 -> _ (숫자용), a -> A (문자용), * -> X (문자+숫자용)로 변환
  return maskPattern
    .replace(/9/g, '_') // 숫자 패턴을 _로 변환
    .replace(/a/g, 'A') // 문자 패턴을 A로 변환
    .replace(/\*/g, 'X'); // 문자+숫자 패턴을 X로 변환
};
